import React from 'react/addons';
import {FluxMixin} from 'fluxxor';
import OnClickOutsideMixin from 'react-onclickoutside';
import cx from 'classnames';

import RawTether from 'ofs/react/RawTether';


var Popover = React.createClass({
  mixins: [
    FluxMixin(React),
    OnClickOutsideMixin
  ],

  getDefaultProps() {
    return {
      panelAttachment: 'top center',
      targetAttachment: 'bottom center'
    };
  },

  getInitialState() {
    return {
      panelStyle: {},
      anchorStyle: {},
      panelClasses: [],
      anchorClasses: []
    };
  },

  close() {
    this.getFlux().actions.layers.remove(this);
  },

  handleClickOutside() {
    this.close();
  },

  getAnchorOptions() {
    return {
      element: this.refs.anchor.getDOMNode(),
      target: this.props.attachTo,
      onPosition: this.onAnchorPosition,
      attachment: 'top center',
      targetAttachment: 'bottom center',
      offset: '5px 0'
    };
  },

  getPanelOptions() {
    return {
      element: this.refs.panel.getDOMNode(),
      target: this.props.attachTo,
      offset: '-10px 0',
      onPosition: this.onPanelPosition,
      attachment: this.props.panelAttachment,
      targetAttachment: this.props.targetAttachment
    };
  },

  onResize() {
    if (this.state.panelTether) {
      this.state.panelTether.setOptions(this.getPanelOptions());
    }
  },

  componentDidMount() {
    var panelTether = new RawTether(this.getPanelOptions());
    var anchorTether = new RawTether(this.getAnchorOptions());
    panelTether.enable();
    anchorTether.enable();
    this.setState({panelTether, anchorTether});

    window.addEventListener('resize', this.onResize);
  },

  onPanelPosition(position, elementClasses, targetClasses) {
    var panelStyle = {
      top: position.page.top,
      left: position.page.left
    };
    var panelClasses = elementClasses;
    this.setState({panelStyle, panelClasses});
  },

  onAnchorPosition(position, elementClasses, targetClasses) {
    var anchorStyle = {
      top: position.page.top,
      left: position.page.left
    };
    var anchorClasses = elementClasses;
    this.setState({anchorStyle, anchorClasses});
  },


  componentWillUnmount() {
    if (this.state.panelTether) {
      this.state.panelTether.disable();
    }
    if (this.state.anchorTether) {
      this.state.anchorTether.disable();
    }
    window.removeEventListener('resize', this.onResize);
  },

  render() {
    var panelClasses = this.state.panelClasses.map(c => 'ofs-Popover__Panel--' + c);
    var anchorClasses = this.state.anchorClasses.map(c => 'ofs-Popover__Anchor--' + c);

    panelClasses.unshift('ofs-Popover__Panel');
    anchorClasses.unshift('ofs-Popover__Anchor');
    panelClasses.unshift('ofs-Popover__Panel--opened');
    anchorClasses.unshift('ofs-Popover__Anchor--opened');

    return (
      <div className="ofs-Popover ignore-react-onclickoutside">
        <div ref="panel" className={cx.apply(this, panelClasses)} style={this.state.panelStyle}>
          {this.props.children}
        </div>
        <div ref="anchor" className={cx.apply(this, anchorClasses)} style={this.state.anchorStyle} />
      </div>
    );
  }
});

export default Popover;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/layers/Popover.jsx
 **/